import React from 'react';
import styles from '../index.module.scss';

interface UserSegmentContentProps {
  description?: string | React.ReactNode;
  note?: React.ReactNode;
  children?: React.ReactNode;
}

const UserSegmentContent: React.FC<UserSegmentContentProps> = ({ description, note, children }) => {
  return (
    <div
      className={styles.deleteAccount__content__body__text}
      data-cy="delete-account-container-content"
    >
      {description && (
        <>
          <p
            data-cy="delete-account-description"
            className={styles.deleteAccount__content__body__text__description}
          >
            {description}
          </p>
        </>
      )}
      {children && (
        <div
          className={styles.deleteAccount__content__body__text__formOptions}
          data-cy="delete-account-form-options"
        >
          {children}
        </div>
      )}
      {note && (
        <p
          className={styles.deleteAccount__content__body__text__note}
          data-cy="delete-account-note"
        >
          {note}
        </p>
      )}
    </div>
  );
};

export default UserSegmentContent;
